import { AgentPurposeModel } from "@/api";

/**
 * OOTB agent purposes returned by AgentPurposeControllerService.listPurposesUsingGet.
 * Used to populate the Purpose ComboBox in the Agent Details section.
 */
const purposes: AgentPurposeModel[] = [
  {
    value: "ANALYTICS",
    displayName: "Analytics",
    description:
      "Aggregate/exploratory analysis for metrics and insights. Deny: raw row dumps, bulk export, writes.",
    allowedActions: ["aggregate_read", "filtered_read"],
  },
  {
    value: "CUSTOMER_SUPPORT",
    displayName: "Customer Support",
    description:
      "Look up individual records to resolve customer issues. Deny: bulk export, writes.",
    allowedActions: ["filtered_read"],
  },
  {
    value: "FRAUD_DETECTION",
    displayName: "Fraud Detection",
    description:
      "Inspect transactions and signals to detect fraudulent activity.",
    allowedActions: ["filtered_read", "aggregate_read"],
  },
  {
    value: "DATA_ENRICHMENT",
    displayName: "Data Enrichment",
    description: "Augment records with derived or third-party attributes.",
    allowedActions: ["filtered_read", "write"],
  },
];

export default purposes;
